import { getPriceRange } from '@streamr/tv-utils';
import { InfoClickSignal, purchaseCustomizationPopup, } from '../components/popups/PurchaseCustomizationPopup';
import { popCheckout } from './popCheckout';
import { popProductInfo } from './popProductInfo';
export async function popPurchaseCustomization({ buyerNickname, customMessage: customMessageParam, product, createCheckoutSession, stripePromise, }) {
    const priceRange = getPriceRange(product.currency);
    let amount = priceRange.defaultUnitAmount;
    let customMessage = customMessageParam;
    try {
        const pricedProduct = await purchaseCustomizationPopup.pop({
            amount,
            minAmount: priceRange.minUnitAmount,
            maxAmount: priceRange.maxUnitAmount,
            buyerNickname,
            customMessage,
            onAmountChange: (value) => {
                amount = value;
            },
            onCustomMessageChange: (value) => {
                customMessage = value;
            },
            product,
        });
        try {
            const checkoutSessionId = await popCheckout(() => createCheckoutSession(pricedProduct, customMessage), stripePromise);
            return {
                checkoutSessionId,
                customMessage,
                pricedProduct,
            };
        }
        catch { }
    }
    catch (e) {
        if (e !== InfoClickSignal) {
            throw e;
        }
        await popProductInfo();
    }
    return popPurchaseCustomization({
        buyerNickname,
        customMessage,
        product,
        createCheckoutSession,
        stripePromise,
    });
}
